import React, { useEffect, useMemo, useState } from 'react';
import MetricsOptions from './MetricsOptions';
import MetricsSetSelect from './MetricsSetSelect';
import { getAllMetricsValue, getMetricsListValue, MetricsType } from './config';
import { useSyncState } from '@op/hooks/common';
import { commonBackInfo } from '@op/components/FilterCommon/utils';
import { SingleCommonType } from '../../types';
import useHistoryFilter from '@op/hooks/useHistoryFilter';
import './index.scss';

export default function MetricsSelect({
  gameInfo,
  onChange,
  defaultKey = 'metrics',
  changeOnCloseWindow,
  filterOptions,
}: SingleCommonType) {
  const allList = useMemo(() => {
    return getAllMetricsValue(gameInfo?.entity_type as any);
  }, []);

  const { addCompetitorFilter } = useHistoryFilter({ gameInfo });
  const [customizedOptions, setCustomizedOptions] = useState(
    (filterOptions?.metrics || []).filter((item: string) =>
      allList.includes(item),
    ),
  );

  // 这个值可能不要，需要根据metricsList来决定
  const {
    state: metricsValue,
    setState: setMetricsValue,
    syncStates: syncStatesMeticsValue,
    revertToPrevious: revertMeticsValue,
  } = useSyncState<MetricsType | 'Customized'>(
    // TODO: 展示处理隐藏Operation Metrics filterOptions?.metricsValue || 'Opinions Overview',
    (filterOptions?.metricsValue === 'Operation Metrics'
      ? 'Opinions Overview'
      : filterOptions?.metricsValue) || 'Opinions Overview',
  );

  const {
    state: selectedMetricsList,
    setState: setSelectedMetricsList,
    previousState,
    syncStates,
    revertToPrevious,
    initStates,
  } = useSyncState<Array<string>>([]);

  useEffect(() => {
    onChangeValue(metricsValue);
    syncStatesMeticsValue();
  }, []);

  function onChangeValue(value: any) {
    setMetricsValue(value);
    syncStatesMeticsValue(value);

    if (value === 'Customized') {
      // 自定义有值，就设置，否则就不做任何操作
      if (customizedOptions.length > 0) initStates(customizedOptions);
    } else {
      initStates(getMetricsListValue(value, gameInfo?.entity_type as any));
    }
    addCompetitorFilter({ metricsValue: value });
  }

  function onConfirm() {
    // 同步状态
    syncStates();
    syncStatesMeticsValue();

    const obj: any = { metricsValue };

    if (metricsValue === 'Customized') {
      obj.metrics = selectedMetricsList;
      setCustomizedOptions(selectedMetricsList);
    }
    // 判断是属于哪个类型的数据
    addCompetitorFilter(obj);
  }

  function changeMetricsValue() {
    setMetricsValue('Customized');
  }

  function clearMetrics() {
    if (selectedMetricsList.length === 0) {
      setSelectedMetricsList(getAllMetricsValue(gameInfo?.entity_type as any));
    } else {
      setSelectedMetricsList([]);
    }
    changeMetricsValue();
  }

  useEffect(() => {
    onChange?.(
      defaultKey,
      commonBackInfo(
        { metrics: previousState },
        { [defaultKey]: previousState },
      ),
    );
    changeOnCloseWindow?.({ metrics: previousState });
  }, [previousState]);

  return (
    <div className="dbo-metrics-select-wrapper">
      <MetricsSetSelect
        value={metricsValue}
        setValue={onChangeValue}
      ></MetricsSetSelect>
      <div className="dbo-compare-select-line"></div>
      <MetricsOptions
        gameInfo={gameInfo as any}
        metricsValue={metricsValue}
        selectedMetricsList={selectedMetricsList}
        setSelectedMetricsList={setSelectedMetricsList}
        resetClick={() => {
          revertToPrevious();
          revertMeticsValue();
        }}
        confirmClick={onConfirm}
        clearMetrics={clearMetrics}
        changeSelect={() => changeMetricsValue()}
      ></MetricsOptions>
    </div>
  );
}
